var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"pb-3"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_c('star-rating',{attrs:{"rtl":_vm.$vs.rtl,"increment":1,"max-rating":_vm.maxRanking,"read-only":_vm.disabled},model:{value:(_vm.answerSend),callback:function ($$v) {_vm.answerSend=$$v},expression:"answerSend"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }